import { useEffect, useState } from 'react';

/**
 * `false` on the first paint, `true` on the next frame.
 *
 * Every drawn figure on this console — the gauge arc, the composition bar, the
 * share line under each tile — is revealed by transitioning `stroke-dashoffset`
 * from "nothing shown" to its real length. A CSS transition needs two frames to
 * see, so the mark has to be painted empty once before it is given its value;
 * this is that first frame.
 *
 * `stroke-dashoffset` rather than a width or a scale on purpose: it is a plain
 * animatable property everywhere, needs no inline style to carry a percentage,
 * and leaves the rounded cap of the mark where it belongs.
 *
 * Motion preference is not read here — the marks that use this all carry
 * `motion-reduce:transition-none`, which lands them on their final value with
 * no run at all.
 */
export function useReveal(): boolean {
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setIsRevealed(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return isRevealed;
}
